import imageStore from "components/ShoppableImage/imageStore"

import "components/ShoppableImage/ShoppableImage.css"
import { observer } from "mobx-react"
import queryString from "qs"
import React from "react"
import { withRouter, Link } from "react-router-dom"
import { Container, Card, Divider, Image, Icon, Header } from "semantic-ui-react"
import shop from "shop/shop"
import ImageCard from "./ImageCard"
import CategoryCard from "./CategoryCard"
import cmsStore from "stores/cmsStore"

@withRouter
@observer
export default class ShoppableImage extends React.Component {

  componentDidMount() {
    imageStore.getIndex()
  }

  render() {
    const query = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    const { useEditor } = cmsStore
    const { images, categories } = imageStore

    return <div className="pv4 pb6">
      <Container>
        <h2>Bildwelten - Alle Kategorien</h2>
        <Card.Group doubling itemsPerRow={3}>
          {categories.map( category => <CategoryCard key={category.term_id} category={category}/> )}
          {useEditor &&
          <Card
            className={"relative"}
            as={"a"}
            href={`${shop.config.BASE}/wp/wp-admin/edit-tags.php?taxonomy=bildwelt_category&post_type=bildwelt`} target={"_blank"}>
            <div className="ph2 pv4">
              <Icon name={"plus"}/> Neue Kategorie anlegen
            </div>
          </Card>}
        </Card.Group>

        <Divider/>

        {/*{categories.map( category => {*/}
          {/*const imagesInCategory = imageStore.byCategory.get( category.slug )*/}
          {/*if ( !imagesInCategory ) return null*/}
          {/*return <div key={category.slug}>*/}
            {/*<div className="pt4 pb3">*/}
              {/*<Header size={"small"}>*/}
                {/*<div className="fw2 black-60 ttu">{category.name}</div>*/}
              {/*</Header>*/}
            {/*</div>*/}
            {/*<Card.Group doubling itemsPerRow={4}>*/}
              {/*{imagesInCategory && imagesInCategory.map( image => <ImageCard key={image.id} image={image}/> )}*/}
              {/*{useEditor && <Card*/}
                {/*className={"relative"}*/}
                {/*as={"a"}*/}
                {/*href={`${shop.config.BASE}/wp/wp-admin/post-new.php?post_type=bildwelt`} target={"_blank"}>*/}
                {/*<div className="ph2 pv4">*/}
                  {/*<Icon name={"plus"}/> Neue Bildwelt anlegen*/}
                {/*</div>*/}
              {/*</Card>}*/}
            {/*</Card.Group>*/}
          {/*</div>*/}
        {/*} )}*/}

      </Container>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/ShoppableImage/ShoppableImageDashboard.js